import { z } from "zod";

const passwordSchema = z
  .string()
  .min(8, "密码至少 8 位")
  .regex(/[A-Za-z]/, "密码需包含字母")
  .regex(/\d/, "密码需包含数字");

export const loginSchema = z.object({
  email: z.string().email("请输入有效邮箱"),
  password: z.string().min(1, "请输入密码")
});

export const registerSchema = z
  .object({
    email: z.string().email("请输入有效邮箱"),
    password: passwordSchema,
    confirmPassword: z.string().min(1, "请再次输入密码")
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "两次输入的密码不一致",
    path: ["confirmPassword"]
  });

export const keyNameSchema = z.object({
  name: z.string().trim().min(2, "名称至少 2 个字符").max(40, "名称最多 40 个字符")
});

export const changeEmailSchema = z.object({
  email: z.string().email("请输入有效邮箱")
});

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "请输入当前密码"),
    password: passwordSchema,
    confirmPassword: z.string().min(1, "请再次输入密码")
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "两次输入的密码不一致",
    path: ["confirmPassword"]
  });
